import { render, staticRenderFns } from "./WkFormItems.vue?vue&type=template&id=6ab965fa&scoped=true"
import script from "./WkFormItems.vue?vue&type=script&lang=js"
export * from "./WkFormItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab965fa",
  null
  
)

export default component.exports